import React, { useEffect, useReducer } from 'react';
import JsonView from '@uiw/react-json-view';
import cn from 'classnames';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';

// TYPES
import { ALL_EVENTS_LIST, EGameEvents } from '@Managers/Events/GameEvents';

// CSS
import styles from './PhaserStatus.scss';

export const PhaserEvents: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer(
        (state: {}, newState: { eventsHistory: Array<{ keyName: string | symbol; data?: {} }>; reviewIndex: number }) => ({
            ...state,
            ...newState
        }),
        { eventsHistory: [], reviewIndex: 0 }
    );

    const excludeEvents: string[] = [EGameEvents.RESIZE_REELS, EGameEvents.RESIZE_SYMBOLS];

    useEffect(() => {
        for (const [key, value] of Object.entries(ALL_EVENTS_LIST)) {
            if (!excludeEvents.includes(key)) EventsCenter.on(key, (data: { source: string }) => eventHit(key, data));
        }
    }, []);
    EGameEvents;

    function eventCheck(index: number) {
        setState({ ...state, reviewIndex: index });
    }

    function eventHit(eventType: string | symbol, payload: { source: string }) {
        let history = state.eventsHistory;
        history?.unshift({ keyName: eventType, data: payload ? payload : {} });
        setState({ eventsHistory: history, reviewIndex: 0 });
    }

    return (
        <div className={styles.phaser_events_container}>
            <div>
                {state.eventsHistory.length > 0 && (
                    <>
                        <div className={styles.phaser_events_header}>Event history</div>
                        <div className={styles.phaser_events_list}>
                            {state.eventsHistory?.map((key: { keyName: string | symbol; source?: string }, index) => {
                                return (
                                    <span className={cn({ [styles.active]: state.reviewIndex === index })} key={index} onPointerDown={() => eventCheck(index)}>
                                        {key.keyName as string}
                                    </span>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
            <div className={cn(styles.phaser_events_data, styles.json_view)}>
                {state.eventsHistory.length > 0 && <JsonView collapsed={2} value={state.eventsHistory[state.reviewIndex].data} />}
            </div>
        </div>
    );
};
